/* src/app/collective-request/collective-request.component.scss */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.error-message {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.error-message span {
  padding: 1rem;
}
.inactive-title {
  margin-bottom: 16px;
  font-size: 26px;
  text-align: center;
  color: var(--primary);
}
.collective-request-wrapper {
  max-width: 600px;
  margin: 0 auto;
}
.collective-request-wrapper:has(.statistics) {
  max-width: 90%;
}
.collective-request-wrapper .statistics {
  margin: 20px auto;
  max-width: 100%;
  text-align: center;
}
.collective-request-wrapper .statistics .subtitle {
  display: flex;
  justify-content: center;
  text-align: center;
  font-size: 38px;
  font-family: "Viga";
  margin: 0 0 16px 0;
  color: var(--primary);
}
.collective-request-wrapper .voucher-ids-section h2 {
  margin-bottom: 0.5rem;
}
.collective-request-wrapper .voucher-ids-section p {
  margin-bottom: 1.5rem;
  color: #666;
}
.collective-request-wrapper .voucher-ids-section .address-group {
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #eee;
}
.collective-request-wrapper .voucher-ids-section .address-group:last-child {
  border-bottom: none;
}
.collective-request-wrapper .voucher-ids-section .address-group mat-form-field {
  margin-bottom: 10px;
}
.collective-request-wrapper .voucher-ids-section .address-group .address-header {
  margin: 0 0 1rem 0;
  font-size: 1.1rem;
  font-weight: 500;
  color: #444;
}
.collective-request-wrapper .voucher-ids-section .address-group .address-row-top {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}
.collective-request-wrapper .voucher-ids-section .address-group .address-row-top .postal-code {
  flex: 1;
}
.collective-request-wrapper .voucher-ids-section .address-group .address-row-top .remove-btn {
  margin-top: 4px;
}
.collective-request-wrapper .voucher-ids-section .address-group .address-row-bottom {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
}
.collective-request-wrapper .voucher-ids-section .address-group .address-row-bottom .house-number {
  flex: 1;
}
.collective-request-wrapper .voucher-ids-section .address-group .address-row-bottom .addition {
  flex: 1;
}
.collective-request-wrapper .voucher-ids-section .address-group mat-error {
  margin-top: 0.25rem;
  font-size: 0.875rem;
  display: block;
}
.collective-request-wrapper .voucher-ids-section .add-voucher-btn {
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.collective-request-wrapper .voucher-ids-section .voucher-count-info {
  margin-bottom: 1.5rem;
  padding: 1rem;
  background-color: #f5f5f5;
  border-radius: 4px;
}
.collective-request-wrapper .voucher-ids-section .voucher-count-info p {
  margin: 0;
  font-weight: 500;
}
.collective-request-wrapper .voucher-ids-section .actions {
  display: flex;
  justify-content: flex-end;
}
.collective-request-wrapper .voucher-ids-section .actions .submit-btn {
  width: 100%;
}
.spinner:before {
  content: "";
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 20px;
  height: 20px;
  margin-top: -10px;
  margin-left: -10px;
  border-radius: 50%;
  border: 2px solid #ffffff;
  border-top-color: #000000;
  animation: spinner 0.8s linear infinite;
}
@keyframes spinner {
  to {
    transform: rotate(360deg);
  }
}
/*# sourceMappingURL=collective-request.component.css.map */
